import ArrowUpFilled from "./SVG/arrow-thick-up-2.svg?react";

const ArrowUpFilledIcon = () => {
  return <ArrowUpFilled />;
};

export default ArrowUpFilledIcon;
